/** @jsx h */
import { Fragment } from 'preact';
import { $, $$ } from 'utils/dom';
import { $search, labels } from '../config';
import FilterFieldset from './FilterFieldset';
// import Sorting from './Sorting';

const FilterContainer = ({
  searchType,
  facets,
  facetsActive,
  triggerAjaxSubmit,
  pluginNamespace,
}) => {
  function handleReset() {
    const radioboxes = $$('.search-section input[type="radio"]', $search);
    if (radioboxes.length) {
      radioboxes.forEach(radiobox => (radiobox.checked = false));
    }

    const checkboxes = $$('.search-section input[type="checkbox"]', $search);
    if (checkboxes.length) {
      checkboxes.forEach(checkbox => (checkbox.checked = false));
    }

    const textfields = $$('input[type="text"]', $search);
    if (textfields.length) {
      textfields.forEach(textfield => (textfield.value = ''));
    }

    triggerAjaxSubmit();
  }

  function activeFilterClick(e) {
    const filterLabel = e.currentTarget.dataset.item;
    const targetCheckbox = $(`[data-label="${filterLabel}"]`);

    // find related checkbox and uncheck it before submit the form
    if (targetCheckbox) {
      targetCheckbox.checked = false;
    }
    triggerAjaxSubmit();
  }

  function facetsAreVisible() {
    return facets.length && facets.some(facet => facet.options.length);
  }

  switch (searchType) {
    case 'global':
    case 'jobs':
    case 'press':
    case 'news':
    case 'article':
    case 'challenges':
      return (
        <div className="search-section__filter">
          <div className="search-section__filters">
            {facetsAreVisible() ? (
              <div className="search-section__filter-category">
                <p className="search-section__category-name">
                  {labels.search.filter}
                </p>
                <ul className="search-section__fieldsets">
                  {facets.map(
                    (facet, index) =>
                      facet.options.length > 0 && (
                        <FilterFieldset
                          searchType={searchType}
                          id={index}
                          key={facet.label}
                          facet={facet}
                          triggerAjaxSubmit={triggerAjaxSubmit}
                          pluginNamespace={pluginNamespace}
                        />
                      )
                  )}
                </ul>
              </div>
            ) : null}
          </div>
          {facetsActive ? (
            <div className="search-section__active-filters">
              <p className="search-section__category-name">
                {labels.search.filterActive}
              </p>
              <div className="search-section__active-filters-wrapper">
                <ul className="search-section__active-filters-list">
                  {facetsActive.selected.map(facet => {
                    return (
                      <li key={`${facet.facet}-${facet.item}`}>
                        <button
                          className="btn btn--primary btn--light"
                          data-facet={facet.facet}
                          data-item={`${facet.name}-${facet.item}`}
                          onClick={activeFilterClick}
                          type="button"
                        >
                          <span>{facet.item}</span>
                          <svg
                            className="svg-close"
                            aria-hidden="true"
                            width="24px"
                            height="24px"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g
                              stroke="none"
                              stroke-width="1"
                              fill-rule="evenodd"
                            >
                              <polygon
                                fill="none"
                                points="0 0 24 0 24 24 0 24"
                              />
                              <polygon
                                fill="currentColor"
                                fill-rule="nonzero"
                                transform="translate(11.939340, 12.060660) rotate(135.000000) translate(-11.939340, -12.060660) "
                                points="1.43933983 11.0606602 22.4393398 11.0606602 22.4393398 13.0606602 1.43933983 13.0606602"
                              />
                              <polygon
                                fill="currentColor"
                                fill-rule="nonzero"
                                transform="translate(12.060660, 12.060660) rotate(45.000000) translate(-12.060660, -12.060660) "
                                points="1.56066017 11.0606602 22.5606602 11.0606602 22.5606602 13.0606602 1.56066017 13.0606602"
                              />
                            </g>
                          </svg>
                        </button>
                      </li>
                    );
                  })}
                  <li>
                    <button
                      className="btn btn--small search-section__reset-btn"
                      onClick={handleReset}
                      type="button"
                    >
                      <span>
                        <span>{labels.faceting.removeAllFilters}</span>
                      </span>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          ) : null}
        </div>
      );
    case 'courses':
      return (
        <div className="search-section__filter">
          <div className="search-section__filters">
            {facetsAreVisible() ? (
              <div className="search-section__filter-category">
                {facets.map(
                  (facet, index) =>
                    facet.options.length > 0 &&
                    facet.name !== 'type' &&
                    facet.type !== 'dateRange' && (
                      <>
                        <p className="search-section__category-name">
                          {facet.label}
                        </p>
                        <ul className="search-section__fieldsets">
                          <FilterFieldset
                            searchType={searchType}
                            id={index}
                            key={facet.label}
                            facet={facet}
                            triggerAjaxSubmit={triggerAjaxSubmit}
                            pluginNamespace={pluginNamespace}
                          />
                        </ul>
                      </>
                    )
                )}
              </div>
            ) : null}
          </div>
          <div className="search-section__filter-footer">
            {facetsActive ? (
              <button
                className="btn btn--small search-section__reset-btn"
                onClick={handleReset}
                type="button"
              >
                <span>
                  <span>{labels.faceting.removeAllFilters}</span>
                </span>
              </button>
            ) : null}
            {labels.faceting.archiveUrl ? (
              <a
                href={`${labels.faceting.archiveUrl}`}
                class="btn btn--tertiary btn--negative"
              >
                {labels.faceting.archiveText}
              </a>
            ) : (
              ''
            )}
          </div>
        </div>
      );
    default:
      return labels.search.unavailable;
  }
};

export default FilterContainer;
